export abstract class CacheHouseProvider {
  abstract getItem(key: string): Promise<any>;
  abstract setItem(key: string, value: any): Promise<any>;
  abstract removeItem(key: string): void;
  abstract getAll(): Promise<any>;
}
